import { animate, animateChild, group, query, sequence, state, style, transition, trigger } from '@angular/animations';

export const mobileNavigationMenuAnimations = [
  trigger('menuContainer', [
    state('collapsed', style({ width: '3.75rem', height: '3.75rem', padding: '1.25rem' })),
    state('expanded', style({ width: '100vw', height: '100dvh', padding: '4rem 1.25rem', borderRadius: 0 })),
    transition(
      '* <=> *',
      group([
        query('@profile', [animateChild()]),
        query('@navigation', [animateChild()]),
        query('@icon', [animateChild()]),
        animate('300ms cubic-bezier(.75,.30,.40,.85)'),
      ]),
    ),
  ]),
  trigger('profile', [
    state('moveRight', style({ transform: 'translateX(50vw)', opacity: '0' })),
    state('moveLeft', style({ transform: 'translateX(0)', opacity: '1' })),
    transition(
      '* <=> *',
      sequence([
        animate('0ms ease-in-out', style({ transform: 'translateX(50vw)', opacity: '0' })),
        animate('500ms ease-in-out', style({ transform: 'translateX(-2vw)', opacity: '1' })),
        animate('200ms ease-in', style({ transform: 'translateX(0)', opacity: '1' })),
      ]),
    ),
  ]),
  trigger('navigation', [
    state('moveDown', style({ transform: 'translateY(50vh)' })),
    state('moveUp', style({ transform: 'translateY(0)' })),
    transition(
      '* <=> *',
      sequence([
        animate('0ms ease-in-out', style({ transform: 'translateY(50vh)', opacity: '0' })),
        animate('500ms ease-in-out', style({ transform: 'translateY(-1rem)', opacity: '1' })),
        animate('200ms ease-in', style({ transform: 'translateY(0)', opacity: '1' })),
      ]),
    ),
  ]),
  trigger('icon', [
    transition(
      'rotateRight => rotateLeft',
      sequence([
        animate('0ms ease-in-out', style({ transform: 'rotate(0)', opacity: '0' })),
        animate('200ms ease-in', style({ transform: 'rotate(90deg)', opacity: '1' })),
      ]),
    ),
    transition(
      'rotateLeft => rotateRight',
      sequence([
        animate('0ms ease-in-out', style({ transform: 'rotate(0)', opacity: '0' })),
        animate('300ms ease-in', style({ transform: 'rotate(-90deg)', opacity: '1' })),
      ]),
    ),
  ]),
];
